import type { NetworkObject as NetworkObjectModel } from '@/adapters/catalogv1.g';

export function extractNetworkObject(model: NetworkObjectModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.network_object_ref ?? '',
    name: model.name ?? '',
    type: model.type,
    status: model.status,
    location: model.location,
    macAddress: model.mac_address,
    ipAddresses: model.ip_addresses?.map((ip) => ({
      address: ip.address,
      type: ip.type,
    })),
    tags: model.tags,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogNetworkObject = ReturnType<typeof extractNetworkObject>;
